import { Typography } from "antd";
import CardChevron from "@/Components/Common/CardChevron";


interface IProps {
	title: string;
	value?: string | number;
	onClick?: () => void;
	placeholder?: string;
}

const DrawerInput = (props: IProps) => {
	const { title, value, placeholder, onClick } = props;

	return (
		<>
			<Typography className="fs-16 fw-500 lh-normal mb-6">
				{title}
			</Typography>
			<div
				className="my-account-item color-757575 align-items-center justify-content-between"
				onClick={() => onClick && onClick()}
			>
				<span className={`fs-16 fw-500 ${value ? "color-2F3034" : ""} lh-normal`}>
					{value || placeholder || ""}
				</span>

				<CardChevron direction="down" width={12} height={7} />
			</div>
		</>
	);
}

export default DrawerInput;
